import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalDraftSync: ExperimentalMutations['experimentalDraftSync'] = async (
	_,
	{ contentId, contentType, title, content, ncsStepVersion },
	{ network: { cfetch } },
) => {
	const history =
		contentType === 'blogpost' ? { createdDate: new Date().toISOString() } : undefined;

	const body = {
		id: contentId,
		type: contentType,
		title,
		body: {
			atlas_doc_format: {
				value: content,
				representation: 'atlas_doc_format',
				content: {
					id: contentId,
				},
			},
		},
		status: 'draft',
		version: {
			number: 1,
			message: '',
			ncsStepVersion,
		},
		extensions: {
			'update-trigger': 'DRAFT_SYNC',
		},
		history,
	};

	try {
		const response = await cfetch(`/wiki/rest/api/content/${contentId}/?status=draft&action=sync`, {
			method: 'PUT',
			headers: {
				'Content-Type': MediaType.JSON,
			},
			body: JSON.stringify(body),
		});
		const responseJson = response.json();
		return responseJson;
	} catch (e) {
		throw e;
	}
};
